<template>
  <!-- 订单详情订单信息 -->
  <div class="det_product">
    <div
      v-if="isGroupOrder && getUserOrder.activityId"
      class="det_item font12 font_weight500 colo087 line_height_17 text_left"
    >
      <div class="flex_left">
        <span class="det_det_title">活动号:</span>
        <span class="det_sn">{{ getUserOrder.activityId }}</span>
      </div>
      <span
        class="copy_btn"
        v-clipboard:copy="getUserOrder.activityId"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        >复制</span
      >
    </div>
    <div
      v-if="isGroupOrder && getUserOrder.groupNo"
      class="det_item font12 font_weight500 colo087 line_height_17 text_left"
    >
      <div class="flex_left">
        <span class="det_det_title">团号:</span>
        <span class="det_sn">{{ getUserOrder.groupNo }}</span>
      </div>
      <span
        class="copy_btn"
        v-clipboard:copy="getUserOrder.groupNo"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        >复制</span
      >
    </div>
    <div
      v-if="isGroupOrder && getUserOrder.joiningGroupNo"
      class="det_item font12 font_weight500 colo087 line_height_17 text_left"
    >
      <div class="flex_left">
        <span class="det_det_title">拼单编号:</span>
        <span class="det_sn">{{ getUserOrder.joiningGroupNo }}</span>
      </div>
      <span
        class="copy_btn"
        v-clipboard:copy="getUserOrder.joiningGroupNo"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        >复制</span
      >
    </div>

    <div
      class="order_id font12 font_weight500 colo087 line_height_20 text_left"
    >
      <div class="flex_left">
        <span class="det_det_title">订单编号:</span>
        <span class="det_sn">{{ getUserOrder.orderSn }}</span>
      </div>
      <div
        v-clipboard:copy="getUserOrder.orderSn"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        class="font_weight400 copy_id"
      >
        复制
      </div>
    </div>
    <div
      v-if="getUserOrder.gmtCreate"
      class="det_item font12 font_weight500 colo087 line_height_17 text_left"
    >
      <span class="det_det_title">下单时间:</span>
      <span class="det_value">{{
        getUserOrder.gmtCreate | dateFormatterJava("YYYY-MM-DD HH:mm:ss")
      }}</span>
    </div>
    <div
      v-if="getUserOrder.payMethod"
      class="det_item font12 font_weight500 colo087 line_height_17 text_left"
    >
      <span class="det_det_title">支付方式:</span>
      <span class="det_value">{{ getUserOrder.payMethod }}</span>
    </div>
    <div
      v-if="getUserOrder.payReference"
      class="det_item font12 font_weight500 colo087 line_height_17 text_left"
    >
      <span class="det_det_title">支付单号:</span>
      <span class="det_value">{{ getUserOrder.payReference }}</span>
    </div>
    <div
      v-if="getUserOrder.payTime"
      class="det_item font12 font_weight500 colo087 line_height_17 text_left"
    >
      <span class="det_det_title">支付时间:</span>
      <span class="det_value">{{
        getUserOrder.payTime | dateFormatterJava("YYYY-MM-DD HH:mm:ss")
      }}</span>
    </div>
    <div
      v-if="getUserOrder.deliveryPlanTime"
      class="det_item font12 font_weight500 colo087 line_height_17 text_left"
    >
      <span class="det_det_title">预计发货日:</span>
      <span class="det_value">{{
        getUserOrder.deliveryPlanTime | dateFormatterJava("YYYY-MM-DD")
      }}</span>
    </div>
    <div
      v-if="getUserOrder.userMessage"
      class="det_item font12 font_weight500 colo087 line_height_17 text_left"
    >
      <span class="det_det_title">买家留言:</span>
      <span class="det_value">{{ getUserOrder.userMessage }}</span>
    </div>
    <div
      v-if="$appSource == 3"
      class="det_item font12 font_weight500 colo087 line_height_17 text_left"
    >
      <span class="det_det_title">配送方式:</span>
      <span class="det_value">{{ deliveryModeTitle }}</span>
    </div>
    <div
      v-if="$appSource == 3 && getUserOrder.valueAddedServiceNames"
      class="det_item font12 font_weight500 colo087 line_height_17 text_left"
    >
      <span class="det_det_title">贴心服务:</span>
      <span class="det_value">{{ getUserOrder.valueAddedServiceNames }}</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    },
    isGroupOrder() {
      // OrderKind 7: Group buying
      return this.getUserOrder.kind === 7;
    },
    deliveryModeTitle() {
      return this.getUserOrder.deliveryMode === 0 ? "自提" : "直邮";
    }
  },
  methods: {
    onCopy() {
      this.$toast("复制成功！");
    },
    onError() {
      this.$toast("复制失败，请重试！");
    }
  }
};
</script>

<style lang="less" scoped>
.det_product {
  background: #fff;
  margin-top: 12px;
  padding: 18px 12px;
  .flex_left {
    display: flex;
    align-items: center;
  }
  .det_sn {
    color: #333;
  }
  .order_id {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding-bottom: 12px;
    padding-top: 6px;
    .copy_id {
      padding: 2px 10px;
      border-radius: 12px;
      background: #f5f5f5;
      font-size: 11px;
      color: rgba(0, 0, 0, 0.4);
    }
  }
  .det_item {
    padding-bottom: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .copy_btn {
      padding: 2px 10px;
      border-radius: 12px;
      background: #f5f5f5;
      font-size: 11px;
      color: rgba(0, 0, 0, 0.4);
    }
  }
  .det_item:last-child {
    padding-bottom: 0;
  }
  .det_det_title {
    width: 72px;
    display: inline-block;
    color: rgba(0, 0, 0, 0.65);
    margin-right: 12px;
  }
  .det_value {
    flex: 1;
    text-align: right;
    color: #333;
  }
}
</style>
